import {useLocation} from '@github-ui/react-router'
import {useNavigate} from '@github-ui/use-navigate'
import {useCallback, useMemo} from 'react'

import {LAYOUT_PARAM, type Layout, readBoardParams} from '../../utils/board-url-params'

/**
 * Owns the saved-view layout URL contract: reads the current layout from the URL and
 * writes it back, clearing `page` because pagination does not translate between layouts.
 */
export function useSavedViewLayout() {
  const {pathname, search} = useLocation()
  const navigate = useNavigate()
  const layout = useMemo(() => readBoardParams(new URLSearchParams(search)).layout, [search])

  const setLayout = useCallback(
    (next: Layout) => {
      if (next === layout) return

      const params = new URLSearchParams(search)
      if (next === 'board') {
        params.set(LAYOUT_PARAM, 'board')
      } else {
        params.delete(LAYOUT_PARAM)
      }
      params.delete('page')
      const query = params.toString()
      navigate(query ? `${pathname}?${query}` : pathname, {preventAutofocus: true})
    },
    [layout, navigate, pathname, search],
  )

  return {layout, setLayout}
}
